import { ISubsidiary } from '../services/subsidiary/subsidiary.model'
import { IUserDetails } from '../services/user-details/user-details.model'

/**
 * The subsidiaries a user may attach NEW data to: the active ones, plus whichever ids are already
 * selected, so a record that sits on a deactivated subsidiary still shows its value while editing.
 * Older cached rows without the flag count as active.
 */
export function getSelectableSubsidiaries(subsidiaries: ISubsidiary[] | null | undefined, keepIds?: string | string[] | null): ISubsidiary[] {
  if (!subsidiaries) return []
  const keep = new Set(Array.isArray(keepIds) ? keepIds : keepIds ? [keepIds] : [])
  return subsidiaries.filter(subsidiary => subsidiary.isActive !== false || keep.has(subsidiary.id))
}

export function getPreferredSubsidiary(subsidiaries: ISubsidiary[], userDetails?: IUserDetails): ISubsidiary | undefined {
  if (!subsidiaries || subsidiaries.length === 0) return undefined
  // New data defaults onto an active subsidiary; the full list is only a fallback for the
  // impossible case of every subsidiary being inactive.
  const active = getSelectableSubsidiaries(subsidiaries)
  const candidates = active.length > 0 ? active : subsidiaries
  if (candidates.length === 1) return candidates[0]

  const byUserDefault = userDetails ? candidates.find(subsidiary => subsidiary.id === userDetails.defaultSubsidiaryId) : undefined
  if (byUserDefault) return byUserDefault

  const primary = candidates.find(subsidiary => (subsidiary as any).isPrimary)
  return primary || candidates[0]
}